import { ENDPOINTS } from "utils/endpoints";
import { GET_API_CALL, POST_API_CALL } from "utils/services";
import { APIResponseModal, ReducersModal } from "utils/modals";
import { createQueryParams } from "utils/constants";
import { UPDATE_ORDER_REDUCER } from "store/actionTypes";
import { USER_TYPE } from "utils/userType";
import {
  mapCarCompanyListItem,
  mapPaginatedResult,
  mapUserDetail,
  mapUserListItem,
  mapVehicleListItem,
  normalizeOrderCouponPayload,
} from "utils/apiMappers";
export const dispatchOrderValue = (payload: any) => {
  return (dispatch: Function, getState: Function) => {
    const store: ReducersModal = getState();
    const orderReducer = store.OrderManagementReducer;
    const newPayload = {
      ...orderReducer.result,
      ...payload,
    };
    dispatch({
      type: UPDATE_ORDER_REDUCER,
      payload: newPayload,
    });
  };
};

let inflightOrderListKey = "";

export const getOrderList = () => {
  return (dispatch: Function, getState: Function) => {
    const store: ReducersModal = getState();
    const orderReducer = store.OrderManagementReducer;
    const {
      result,
      limit,
      page,
      sortOrder,
      sortedBy,
      search,
      serviceTypeId,
      orderStatus,
      paymentType,
      userId,
      merchantId,
      category,
    } = orderReducer;

    dispatch({
      type: UPDATE_ORDER_REDUCER,
      payload: {
        result,
        limit,
        page,
        sortOrder,
        sortedBy,
        search,
        serviceTypeId,
        orderStatus,
        paymentType,
        userId,
        merchantId,
        category,
        isLoading: true,
      },
    });

    let queryParams = createQueryParams({
      page,
      limit,
      search,
      sortedBy,
      sortOrder,
    });

    if (serviceTypeId && serviceTypeId !== "-1") {
      queryParams = `${queryParams}&serviceTypeId=${serviceTypeId}`;
    }

    if (orderStatus) {
      if (orderStatus !== "-1") {
        queryParams = `${queryParams}&orderStatus=${orderStatus}`;
      }
    }
    if (paymentType !== "-1") {
      queryParams = `${queryParams}&paymentMode=${paymentType}`;
    }
    if (userId) {
      queryParams = `${queryParams}&userId=${userId}`;
    }
    if (merchantId) {
      queryParams = `${queryParams}&merchantId=${merchantId}`;
    }
    if (category !== "-1" && category !== "" && category != null) {
      queryParams = `${queryParams}&category=${category}`;
    }

    if (inflightOrderListKey === queryParams) {
      return;
    }
    inflightOrderListKey = queryParams;

    GET_API_CALL(
      ENDPOINTS.ORDER_MANAGEMENT.ALL_ORDERS + "?",
      queryParams,
      (response: APIResponseModal) => {
        if (inflightOrderListKey === queryParams) inflightOrderListKey = "";
        if (response.isSuccess) {
          const listData = response.data || {};
          const orders = Array.isArray(listData.data) ? listData.data : [];
          dispatch({
            type: UPDATE_ORDER_REDUCER,
            payload: {
              result: page > 1 ? [...result, ...orders] : orders,
              page: listData.page || page,
              limit: listData.limit || limit,
              totalPages: listData.totalPages || 1,
              totalRecords: listData.total ?? 0,
              isLoading: false,
            },
          });
        } else {
          dispatch({
            type: UPDATE_ORDER_REDUCER,
            payload: {
              isLoading: false,
            },
          });
        }
      },
    );
  };
};

export const getUserBy = (payload: any, callback: any) => {
  return (dispatch: Function, getState: Function) => {
    GET_API_CALL(
      ENDPOINTS.USERS.LISTING + "?",
      `page=1&type=${payload.userType}`,
      (response: APIResponseModal) => {
        const store: ReducersModal = getState();
        const { createOrder } = store.OrderManagementReducer;
        const newList: any = {};
        const isCustomer = Number(payload.userType) === USER_TYPE.CUSTOMER;
        const isMerchant = Number(payload.userType) === USER_TYPE.MERCHANT;

        if (response.isSuccess && response.data) {
          const { result } = mapPaginatedResult(response.data, mapUserListItem);
          if (isCustomer) newList.userList = result;
          if (isMerchant) newList.merchantList = result;
          dispatch({
            type: UPDATE_ORDER_REDUCER,
            payload: {
              createOrder: { ...createOrder, ...newList },
            },
          });
          callback(result);
        } else {
          if (isCustomer) newList.userList = [];
          if (isMerchant) newList.merchantList = [];
          dispatch({
            type: UPDATE_ORDER_REDUCER,
            payload: {
              createOrder: { ...createOrder, ...newList },
            },
          });
        }
      },
    );
  };
};

let serviceListRequestId = 0;

export const getServiceList = (callback: any, category: string) => {
  return (dispatch: Function, getState: Function) => {
    const requestId = ++serviceListRequestId;
    const store: ReducersModal = getState();
    const { createOrder } = store.OrderManagementReducer;
    dispatch({
      type: UPDATE_ORDER_REDUCER,
      payload: {
        createOrder: { ...createOrder, serviceList: [] },
      },
    });
    GET_API_CALL(
      ENDPOINTS.SERVICE.SERVICE_LISTING + "?",
      `category=${category}`,
      (response: APIResponseModal) => {
        if (requestId !== serviceListRequestId) {
          return;
        }
        const latestStore: ReducersModal = getState();
        const latestCreateOrder = latestStore.OrderManagementReducer.createOrder;
        const data = Array.isArray(response.data?.data)
          ? response.data.data
          : Array.isArray(response.data?.result)
            ? response.data.result
            : [];
        const list = response.isSuccess && response.data ? data : [];
        dispatch({
          type: UPDATE_ORDER_REDUCER,
          payload: {
            createOrder: { ...latestCreateOrder, serviceList: list },
          },
        });
        callback(list);
      },
    );
  };
};

// export const getAllServiceType = () => {
//   return (dispatch: Function) => {
//     GET_API_CALL(
//       ENDPOINTS.SERVICE.TYPE_LISTING + "?",
//       "",
//       (response: APIResponseModal) => {
//         if (response.isSuccess && response.data) {
//           dispatch({
//             type: UPDATE_ORDER_REDUCER,
//             payload: {
//               serviceTypesList: response.data.result,
//             },
//           });
//         }
//       },
//     );
//   };
// };

export const getOrderCarType = (callback: any) => {
  return (dispatch: Function, getState: Function) => {
    GET_API_CALL(
      ENDPOINTS.UTILITY.CARS_TYPE_LISTING + "?",
      "",
      (response: APIResponseModal) => {
        const store: ReducersModal = getState();
        const { createOrder } = store.OrderManagementReducer;
        if (response.isSuccess && response.data) {
          const { result } = response.data;
          dispatch({
            type: UPDATE_ORDER_REDUCER,
            payload: {
              createOrder: { ...createOrder, carTypeList: result },
            },
          });
          callback(result);
        } else {
          dispatch({
            type: UPDATE_ORDER_REDUCER,
            payload: {
              payload: {
                createOrder: { ...createOrder, carTypeList: [] },
              },
            },
          });
        }
      },
    );
  };
};

export const createNewOrder = (payload: any, callback: any) => {
  return () => {
    const nextPayload = { ...payload };

    if (nextPayload.slot?.date) {
      const rawDate = `${nextPayload.slot.date}`.trim();
      const calendarDate = rawDate.match(/^(\d{4}-\d{2}-\d{2})/)?.[1] || rawDate;
      nextPayload.slot = {
        ...nextPayload.slot,
        date: calendarDate,
      };
    }
    const rawDiscount = nextPayload.discount;
    const discountValue =
      rawDiscount !== null &&
        rawDiscount !== undefined &&
        typeof rawDiscount === "object"
        ? Number(rawDiscount.value)
        : Number(rawDiscount);
    if (!Number.isFinite(discountValue) || discountValue <= 0) {
      delete nextPayload.discount;
    } else {
      nextPayload.discount = discountValue;
    }
    if (nextPayload.coupon !== undefined) {
      const coupon = normalizeOrderCouponPayload(nextPayload.coupon);
      if (coupon) nextPayload.coupon = coupon;
      else delete nextPayload.coupon;
    }


    POST_API_CALL(
      ENDPOINTS.ORDER_MANAGEMENT.CREATE_ORDER,
      nextPayload,
      (response: APIResponseModal) => {
        if (response.isSuccess && response.data) {
          callback(response.data);
          return;
        }
        callback(null);
      },
    );
  };
};

export const getOrderPrice = (payload: any, callback: any) => {
  return () => {
    GET_API_CALL(
      ENDPOINTS.SERVICE_PRICING.SERVICE_PRICE + "?",
      createQueryParams({
        carTypeId: payload.carTypeId,
        serviceTypeId: payload.serviceTypeId,
      }),
      (response: APIResponseModal) => {
        if (response.isSuccess && response.data) {
          const { result } = response.data;
          callback(result);
        } else {
          callback(null);
        }
      },
    );
  };
};

const inflightOrderDetails: Record<string, Function[]> = {};

export const getOrderDetails = (orderId: any, callback: any) => {
  return () => {
    const id = `${orderId || ""}`.trim();
    if (!id) {
      callback(null);
      return;
    }
    if (inflightOrderDetails[id]) {
      inflightOrderDetails[id].push(callback);
      return;
    }
    inflightOrderDetails[id] = [callback];
    GET_API_CALL(
      `${ENDPOINTS.ORDER_MANAGEMENT.ORDER_DETAILS}/${id}`,
      "",
      (response: APIResponseModal) => {
        const cbs = inflightOrderDetails[id] || [];
        delete inflightOrderDetails[id];
        const result =
          response.isSuccess && response.data
            ? (() => {
              const raw = response.data;
              const nested =
                raw?.result &&
                  typeof raw.result === "object" &&
                  !Array.isArray(raw.result)
                  ? raw.result
                  : null;
              return nested ? { ...raw, ...nested } : raw;
            })()
            : null;
        cbs.forEach((cb) => cb(result));
      }
    );
  };
};

export const getUserDetails = (
  userId: any,
  callback: any,
  dateRange?: { startDate?: string; endDate?: string },
) => {
  return () => {
    const hasRange = Boolean(dateRange?.startDate && dateRange?.endDate);
    const query = hasRange
      ? `?startDate=${encodeURIComponent(
        dateRange?.startDate || "",
      )}&endDate=${encodeURIComponent(dateRange?.endDate || "")}`
      : "";
    GET_API_CALL(
      `${ENDPOINTS.USERS.USER_DETAIL}/${userId}`,
      query,
      (response: APIResponseModal) => {
        if (response.isSuccess && response.data) {
          const result = mapUserDetail(response.data);
          callback({ isSuccess: true, result });
        } else {
          callback({ isSuccess: false, result: {} });
        }
      },
    );
  };
};

export const updateOrderDetails = (payload: any, callback: any) => {
  return () => {
    POST_API_CALL(
      ENDPOINTS.ORDER_MANAGEMENT.UPDATE_ORDER_DETAILS,
      payload.data,
      (response: APIResponseModal) => {
        if (response.isSuccess) {
          callback(response);
        } else {
          callback(null);
        }
      },
    );
  };
};

export const getUsersBySearch = (
  search: string,
  userType: number,
  callback: any,
) => {
  return () => {
    const queryParams = ["page=1", `type=${userType}`];
    if (search) queryParams.push(`search=${encodeURIComponent(search)}`);

    GET_API_CALL(
      ENDPOINTS.USERS.LISTING,
      `?${queryParams.join("&")}`,
      (response: APIResponseModal) => {
        if (response.isSuccess && response.data) {
          const { result } = mapPaginatedResult(response.data, mapUserListItem);
          callback(result);
        } else {
          callback([]);
        }
      },
    );
  };
};

export const getCarCompaniesBySearch = (search: string, callback: any) => {
  return () => {
    GET_API_CALL(
      ENDPOINTS.COMPANIES.COMPANIESLIST + "?",
      createQueryParams({
        search,
        page: 1,
      }),
      (response: APIResponseModal) => {
        if (response.isSuccess && response.data) {
          const { result } = mapPaginatedResult(
            response.data,
            mapCarCompanyListItem,
          );
          callback(result);
        } else {
          callback([]);
        }
      },
    );
  };
};

/**
 * GET /api/v1/shinology/vehicle/get-vehicle
 * Filters: name, vehicleType, companyId
 */
export const getVehiclesBySearch = (
  search: string,
  companyId: string,
  callback: any,
  vehicleType: string = "0",
) => {
  return () => {
    // Build query explicitly so vehicleType "0" is never dropped by createQueryParams.
    // Omit empty `name` — API rejects name="".
    const queryParts = [
      // `vehicleType=${encodeURIComponent(vehicleType)}`,
      `companyId=${encodeURIComponent(companyId)}`,
    ];
    if (search?.trim()) {
      queryParts.unshift(`name=${encodeURIComponent(search.trim())}`);
    }
    const query = queryParts.join("&");
    GET_API_CALL(
      ENDPOINTS.VEHICLE.VEHICLE_LIST + "?",
      query,
      (response: APIResponseModal) => {
        if (response.isSuccess && response.data) {
          const { result } = mapPaginatedResult(
            response.data,
            mapVehicleListItem,
          );
          callback(Array.isArray(result) ? result : []);
        } else {
          callback([]);
        }
      },
    );
  };
};

export const getCurrentDiscount = (callback: any) => {
  return (dispatch: Function) => {
    GET_API_CALL(
      ENDPOINTS.UTILITY.CURRENT_DISCOUNT,
      "",
      (response: APIResponseModal) => {
        if (response.isSuccess && response.data) {
          const { result } = response.data;
          dispatch({
            type: UPDATE_ORDER_REDUCER,
            payload: {
              currentDiscount: { ...result },
            },
          });
          callback(result);
        } else {
          dispatch({
            type: UPDATE_ORDER_REDUCER,
            payload: {
              payload: {
                currentDiscount: { discountValue: 0 },
              },
            },
          });
        }
      },
    );
  };
};


export const getServiceCategories = (callback: any) => {
  return (dispatch: Function, getState: Function) => {
    GET_API_CALL(
      ENDPOINTS.UTILITY.SERVICE_CATEGORIES_LISTING + "?",
      "page=1&limit=10",
      (response: APIResponseModal) => {
        const store: ReducersModal = getState();
        const { createOrder } = store.OrderManagementReducer;
        if (response.isSuccess && response.data) {
          const { data } = response.data;
          dispatch({
            type: UPDATE_ORDER_REDUCER,
            payload: {
              createOrder: { ...createOrder, serviceCategoryList: data },
            },
          });
          callback(data);
        } else {
          dispatch({
            type: UPDATE_ORDER_REDUCER,
            payload: {
              payload: {
                createOrder: { ...createOrder, serviceCategoryList: [] },
              },
            },
          });
        }
      },
    );
  };
};

/** GET /api/v1/shinology/address/list?userId= */
export const getUserAddressList = (userId: string, callback: any) => {
  return () => {
    if (!userId) {
      callback([]);
      return;
    }
    GET_API_CALL(
      ENDPOINTS.USERS.ADDRESS_LIST + "?",
      `userId=${userId}`,
      (response: APIResponseModal) => {
        if (response.isSuccess && response.data) {
          const list = Array.isArray(response.data?.data)
            ? response.data.data
            : Array.isArray(response.data)
              ? response.data
              : [];
          callback(list);
        } else {
          callback([]);
        }
      },
    );
  };
};

/** GET /api/v1/shinology/car/service-list/{userVehicleId} */
export const getVehicleServiceList = (
  userVehicleId: string,
  callback: any,
) => {
  return (dispatch: Function, getState: Function) => {
    if (!userVehicleId) {
      callback([]);
      return;
    }
    GET_API_CALL(
      `${ENDPOINTS.SERVICE.VEHICLE_SERVICE_LIST}/${userVehicleId}`,
      "",
      (response: APIResponseModal) => {
        const store: ReducersModal = getState();
        const { createOrder } = store.OrderManagementReducer;
        if (response.isSuccess && response.data) {
          const data = Array.isArray(response.data?.data)
            ? response.data.data
            : Array.isArray(response.data?.result)
              ? response.data.result
              : Array.isArray(response.data)
                ? response.data
                : [];
          dispatch({
            type: UPDATE_ORDER_REDUCER,
            payload: {
              createOrder: { ...createOrder, serviceList: data },
            },
          });
          callback(data);
        } else {
          dispatch({
            type: UPDATE_ORDER_REDUCER,
            payload: {
              createOrder: { ...createOrder, serviceList: [] },
            },
          });
          callback([]);
        }
      },
    );
  };
};